
import fitvids from 'fitvids'
import postQuery from '~/apollo/queries/post'
export default {
  layout: 'journalPages',
  async asyncData ({ $graphql, params }) {
    const variables = { slug: params.slug }
    const data = await $graphql.default.request(postQuery, variables)
    return {
      data: data.post
    }
  },
  data () {
    return {
      showSocial: false,
      post: {},
      loading: 0,
      scrollpx: 0,
      imgWidth: '100%'
    }
  },
  head () {
    return {
      title: this.metaTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.metaDesc
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.metaTitle
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: 'https://studio375.it' + this.path
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.metaDesc
        },
        {
          hid: 'og:locale',
          property: 'og:locale',
          content: 'it_IT'
        },
        {
          hid: 'og:site_name',
          property: 'og:site_name',
          content: 'Studio375'
        },
        ...(this.noindex ? [{ name: 'robots', content: 'noindex' }] : [])
      ],
      link: [
        {
          rel: 'canonical',
          href: 'https://studio375.it' + this.path
        }
      ],
      bodyAttrs: {
        class: 'single-post journal-post'
      }
    }
  },
  computed: {
    slug () {
      return this.$route.params.slug
    },
    path () {
      if (this.$route.path.charAt(this.$route.path.length - 1) === '/') {
        return this.$route.path
      } else {
        return this.$route.path + '/'
      }
    },
    title () {
      return (!this.loading) ? this.data.title : ''
    },
    preVideo () {
      // let url = (this.post.dettagli_post !== undefined && !this.loading) ? this.post.dettagli_post.urlVideo : null
      // if (url) {
      //   const split = url.split('https://dna.studio375.it/wp-content')
      //   url = split[1]
      // }
      const url = (this.data.dettagli_post !== undefined && !this.loading) ? this.data.dettagli_post.urlVideo : null
      return url
    },
    noindex () {
      return this.data.dettagli_post !== undefined && this.data.dettagli_post.noindex && !this.loading
    },
    excerpt () {
      return (!this.loading) ? this.data.excerpt : ''
    },
    cliente () {
      return (this.data.clienti !== undefined && !this.loading) ? this.data.clienti.edges[0].node.name : ''
    },
    // coloreCliente () {
    //   return (this.post.clienti !== undefined && !this.loading) ? this.post.clienti.edges[0].node.dettagli_cliente.coloreDiRiferimento : ''
    // },
    // cssVars () {
    //   if (this.coloreCliente !== '' && this.coloreCliente !== null) {
    //     return {
    //       '--client-color': this.coloreCliente
    //     }
    //   }

    //   return null
    // },
    clienteSlug () {
      return (this.data.clienti !== undefined && !this.loading) ? this.data.clienti.edges[0].node.slug : ''
    },
    categoria () {
      let ret = ''
      if (!this.loading && this.data.categories !== undefined) {
        const cats = this.data.categories.edges
        ret = cats
        /* let first = true
        for (let i = 0; i < cats.length; i++) {
          if (first) {
            ret += cats[i].node.name
            first = false
          } else {
            ret += ', ' + cats[i].node.name
          }
        } */
      }
      return ret
    },
    categoriaSlug () {
      return (this.data.categories !== undefined && !this.loading) ? this.data.categories.edges[0].node.slug : ''
    },
    img () {
      // let url = (this.post.featuredImage !== undefined && this.post.featuredImage !== null && !this.loading) ? this.post.featuredImage.node.sourceUrl : null
      // if (url) {
      //   const split = url.split('https://dna.studio375.it/wp-content')
      //   url = split[1]
      // }
      const url = (this.data.featuredImage !== undefined && this.data.featuredImage !== null && !this.loading) ? this.data.featuredImage.node.sourceUrl : null
      return url
    },
    tags () {
      let ret = ''
      if (!this.loading && this.data.tags !== undefined) {
        const tags = this.data.tags.edges
        for (let i = 0; i < tags.length; i++) {
          if (i === 0) {
            ret += tags[i].node.name
          } else {
            ret += ', ' + tags[i].node.name
          }
        }
      }
      return ret
    },
    content () {
      return (!this.loading && this.data.dettagli_post !== undefined) ? this.data.dettagli_post.contenuto : ''
    },
    linkSito () {
      return (this.data.dettagli_post !== undefined && !this.loading) ? this.data.dettagli_post.linkSito : null
    },
    metaDesc () {
      return (this.data.seo !== undefined && !this.loading) ? this.data.seo.metaDesc : this.title
    },
    metaTitle () {
      return (this.data.seo !== undefined && !this.loading) ? this.data.seo.title : this.title
    },
    nextPost () {
      const next = (this.data.previous && this.data.previous.slug && !this.loading) ? this.data.previous.slug : this.$store.state.firstPost
      return next
    },
    nextPostByCat () {
      const all = this.$store.state.postsCurrentCat
      let next = false
      if (all) {
        all.forEach((p, i) => {
          if (p.node.slug === this.slug) {
            if (all[i + 1]) {
              next = all[i + 1].node.slug
            } else {
              next = all[0].node.slug
            }
          }
        })
      }

      return next
    }
  },
  mounted () {
    this.$nextTick(function () {
      const _this = this
      window.addEventListener('scroll', _this.fillTitle)
      setTimeout(function () {
        _this.playVideo()
      }, 300)
    })
  },
  beforeDestroy () {
    const _this = this
    window.removeEventListener('scroll', _this.fillTitle)
  },
  methods: {
    fillTitle () {
      this.scrollpx = document.documentElement.scrollTop

      if (window.innerWidth >= 1024) {
        const title = document.getElementsByClassName('title-scroll')[0]
        const share = document.getElementsByClassName('share')[1]
        if (this.scrollpx >= 225) {
          title.classList.add('filled')
          share.classList.add('filled')
        } else {
          title.classList.remove('filled')
          share.classList.remove('filled')
        }
      } else {
        const titleMobile = document.getElementsByClassName('title-mobile')[0]
        if (this.scrollpx >= 130) {
          titleMobile.classList.add('visible')
        } else {
          titleMobile.classList.remove('visible')
        }
      }
    },
    playVideo () {
      if (this.$refs.v !== undefined) {
        const _this = this
        setTimeout(function () {
          _this.$refs.v.play()
        }, 600)
      }
    },
    initFitVids () {
      fitvids()
    },
    to () {
      // this.$router.push(this.$store.state.backProjectsPath)
      let from = this.$nuxt.context.from.path
      from = from.replace('/progetti/', '')
      if (!this.$store.state.postsPath.includes(from)) {
        this.$router.go(-1)
      } else {
        this.$router.push(this.$store.state.backProjectsPath)
      }
    },
    stopVideo () {
      this.isHome = false
      if (this.$refs.v !== undefined) {
        this.$refs.v.pause()
      }
    }
  }
}
